import { DotLegalSelectOption } from "../../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types";

export interface LegalBasisSelectorViewModel {
    directives: Array<LegalBasisSelectOption>;
    nationalLaws: Array<LegalBasisSelectOption>;
    doubleLegalBases: Array<LegalBasisSelectOption>;
}

export class LegalBasisSelectOption implements DotLegalSelectOption {
    name: string;
    id: string;
    balanceOfInterests: boolean;

    constructor(name: string, id: string, balanceOfInterests: boolean) {
        this.name = name;
        this.id = id;
        this.balanceOfInterests = balanceOfInterests;
    }
}

export enum LegalBasisType {
    Directive,
    NationalLaw,
    DoubleLegalBasis,
}
